import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HomepageDataService } from 'src/app/services/homepageData/homepageData.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dist-dashboard',
  templateUrl: './dist-dashboard.component.html',
  styleUrls: ['./dist-dashboard.component.scss'],
})
export class DistDashboardComponent implements OnInit {

  isLoading: boolean = false;
  public charts: string[] = [];
  public kpis: string[] = [];
  kpiData: any[] = [];
  kpi: any;
  hasMeteredBilling: Observable<boolean> | undefined;
  chartData: { id: number, name: string, type: string, value: string }[] = [];
  labelArray: string[] = [];
  valuesArray: number[] = [];
  alertBarChartValues: number[] = [0, 0];

  userDistId?: number;

  constructor(
    private _authorizeService: AuthorizeService,
    private _router: Router,
    private _homepageDataService: HomepageDataService) {
    this._authorizeService.user$.subscribe(user => {
      this.userDistId = user?.distributorId;
    });
  }

  ngOnInit() {
    //Temporarily navigating away from dashboard
    let url: string = "/dashboard/tanks/tanks";
    this._router.navigate([url]);

    /* this._homepageDataService.checkMeteredBilling$(this.userDistId!).pipe(
      map((data: any) => {
        this.hasMeteredBilling = data;
      })).subscribe();

    if ("homepageChartData" in sessionStorage) {
      let chartJson = sessionStorage.getItem('homepageChartData') || '{}';
      this.chartData = JSON.parse(chartJson);
    } else {
      this.isLoading = true;
      this._homepageDataService.getChartData$(this.userDistId!).pipe(
        map((data: any) => {
          this.chartData = data;
          sessionStorage.setItem('homepageChartData', JSON.stringify(this.chartData));
          if (this.charts.length < 1) {
            for (let x = 0; x < this.chartData.length; x++) {
              this.charts.push(data[x].id);
            }
          }
          return data;
        })
      ).subscribe((data: any) => this.chartData = data);
      this.isLoading = false;
    }

    if ("homepageKpiData" in sessionStorage) {
      let kpiJson = sessionStorage.getItem("homepageKpiData") || '{}';
      this.kpiData = JSON.parse(kpiJson);

      if ("homepageKpis" in sessionStorage) {
        let kpisJson = sessionStorage.getItem("homepageKpis") || '{}';
        this.kpis = JSON.parse(kpisJson);
      }
    } else {
      this.isLoading = true;
      this._homepageDataService.getKPIData$(this.userDistId!).pipe(
        map((data: any) => {
          this.kpiData = data;
          sessionStorage.setItem('homepageKpiData', JSON.stringify(this.kpiData));
          if (this.kpis.length < 1) {
            for (let x = 0; x < this.kpiData.length; x++) {
              this.kpis.push(data[x].id);
            }
          }
          sessionStorage.setItem('homepageKpis', JSON.stringify(this.kpis));
          this.isLoading = false;
          return data;
        })
      ).subscribe((data: any) => this.kpiData = data);
    } */
   
  }

}
